import React from "react";
import { Stack } from "@mui/material";

import { MainInfo } from "src/widgets/MainInfo";
import { PartnersMarquee } from "src/widgets/PartnersMarquee";
import { RoutePaths } from "src/app/model";

export const HomePage: React.FC = () => {
  return (
    <Stack
      width={1}
      direction="column"
      gap={8}
      id={RoutePaths.HOME}
      sx={{
        scrollMarginTop: 80,
      }}
    >
      <MainInfo />

      <PartnersMarquee />
    </Stack>
  );
};
